import React, { useEffect, Suspense, lazy } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { TrustBadgeSection } from '../components/TrustBadgeSection';
const SalesLetterSection = lazy(() => import('../components/SalesLetterSection').then(m => ({
  default: m.SalesLetterSection
})));
const BonusesSection = lazy(() => import('../components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const CheckoutSection = lazy(() => import('../components/CheckoutSection').then(m => ({
  default: m.CheckoutSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ObjectionsSection = lazy(() => import('../components/ObjectionsSection').then(m => ({
  default: m.ObjectionsSection
})));
const ClosingCTASection = lazy(() => import('../components/ClosingCTASection').then(m => ({
  default: m.ClosingCTASection
})));
const PurchasePopup = lazy(() => import('../components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function LandingPage() {
  useEffect(() => {
    document.title = 'HUERTA 360';
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-black text-gray-200 font-sans selection:bg-green-500 selection:text-black" data-id="element-261">
      <UrgencyBar data-id="element-262" />

      <main className="pt-9" data-id="element-263">
        <HeroSection data-id="element-264" />
        <TrustBadgeSection data-id="element-265" />
        <Suspense fallback={null} data-id="element-266">
          <SalesLetterSection data-id="element-267" />
          <BonusesSection data-id="element-268" />
          <CheckoutSection data-id="element-269" />
          <GuaranteeSection data-id="element-270" />
          <TestimonialsSection data-id="element-271" />
          <ObjectionsSection data-id="element-272" />
          <ClosingCTASection data-id="element-273" />
        </Suspense>
      </main>

      <footer className="py-12 bg-zinc-950 border-t border-zinc-900 text-center text-zinc-600 text-sm" data-id="element-274">
        <div className="max-w-6xl mx-auto px-4" data-id="element-275">
          <p className="mb-4" data-id="element-276">
            © 2025 Huerta Productiva 360°. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-277">
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-278">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-279">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-280">
              Soporte
            </a>
          </div>
        </div>
      </footer>

      <Suspense fallback={null} data-id="element-281">
        <PurchasePopup data-id="element-282" />
      </Suspense>
    </div>;
}